var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard",style:(_vm.dashboardStyle),attrs:{"id":"dashboard"}},[_c('appheader'),_vm._v(" "),_c('div',{class:{'header-space': _vm.config.showHeader},attrs:{"id":"main"}},[_c('router-view',{attrs:{"id":_vm.id}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289af36a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 583
// module chunks = 1